import { Box, CircularProgress, Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import { o365gateway } from "@dashboard-v3/api";
import { useTranslation } from "react-i18next";

type Params = {
  progress?: o365gateway.OperationProgress;
  operationCompleted?: boolean;
};

export default function ProgressMsg({ progress, operationCompleted }: Params) {
  const { t } = useTranslation("gateway");
  const events = progress?.progress ?? [];

  if (events.length === 0) {
    return (
      <Box display="flex" alignItems="center" gridGap="8px">
        <CircularProgress size={14} />
        
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gridGap="6px" maxWidth="500px">
      {events.map((step, i) => {
        const isLast = i === events.length - 1;
        const isDone = !isLast || operationCompleted;

        return (
          <Box
            key={`${step.code}-${i}`}
            display="flex"
            alignItems="center"
            gridGap="8px"
          >
            {isDone ? (
              <CheckIcon style={{ fontSize: 16, color: "green" }} />
            ) : (
              <CircularProgress size={14} />
            )}
            <Typography variant="body2">
              {t(`o365Gateway.step.${step.code}.${step.status}`, step.message)}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
